export const BEHAVIOUR_LISTING_COLUMNS = [
    'Client',
    'Note Type',
    'Range',
    'Created At',
  ]
  
  export const BEHAVIOUR_SORTING_COLUMNS = {
    'Client': 'clientFullName',
    'Note Type':'noteType',
    'Range': 'range',
    'Created At': 'createdAt',
  }
  
  export const BEHAVIOUR_COLUMNS_DATA_MAPPING = {
    'Client': 'clientFullName',
    'Note Type':'noteType',
    'Range': 'range',
    'Created At': 'createdAt',
  }

  export const BEHAVIOUR_ASSESSMENT_LISTING_COLUMNS = [
    'Client Name',
    'Note Type',
    'Created At',
  ]
  
  export const BEHAVIOUR_ASSESSMENT_SORTING_COLUMNS = {
    'Client Name': 'clientName',
    'Note Type':'noteType',
    'Created At': 'createdAt',
  }
  
  export const BEHAVIOUR_ASSESSMENT_COLUMNS_DATA_MAPPING = {
    'Client Name': 'clientName',
    'Note Type':'noteType',
    'Created At': 'createdAt',
  }